import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EventType, EventTypeFilters, getEventTypeStatusDisplay } from '../../../../../models/event-type';
import { AccountService } from '../../../../../services/account/account.service';
import { EventTypeService } from '../../../../../services/event-type/event-type.service';
import { searchList } from '../../../../../utils';
import { EventTypeStatus } from '../../../../../models/event-type-enums';


@Component({
  selector: 'app-select-event-type-modal',
  templateUrl: './select-event-type-modal.component.html',
  styleUrls: ['./select-event-type-modal.component.css']
})
export class SelectEventTypeModalComponent implements OnInit {

  @Input() excludeIds: number[];
  @Input() filters: EventTypeFilters = {};
  @Input() submitCallback: (eventType: EventType) => undefined;

  public loadingEventTypes = false;
  public searchInput = '';

  public eventTypes: EventType[];
  public selectedEventType: EventType = null;

  public serverError: number = null;

  public EventTypeStatus = EventTypeStatus;
  public getEventTypeStatusDisplay = getEventTypeStatusDisplay;

  constructor(
    public activeModal: NgbActiveModal,
    private eventTypeService: EventTypeService,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.loadEventTypes();
  }

  public filteredEventTypes(): EventType[] {
    return searchList<EventType>(
      this.searchInput,
      this.eventTypes.map(et => {
        return {
          value: et,
          searchableText: et.name
        };
      })
    );
  }

  public handleSearchInputChange() {
    this.selectedEventType = null;
  }

  public selectEventType(et: EventType) {
    this.selectedEventType = et;
    this.searchInput = et.name;
  }

  public validInputSelected() {
    return this.selectedEventType !== null;
  }

  public handleSave() {
    this.submitCallback(this.selectedEventType);
    this.activeModal.close();
  }

  private loadEventTypes() {
    this.loadingEventTypes = true;

    this.eventTypeService
      .getEventTypes(1, 3000, this.filters)
      .then(response => {
        this.eventTypes = response.results.filter(et => !this.excludeIds.includes(et.id));
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEventTypes = false; });
  }
}
